'use strict'
/**
 * 単品商品追加Mixin
 * @param Object selectItem 選択した商品の情報を持つオブジェクト
 */
function addSingleItem (selectItem) {
  const item = {
    coupon_cd: selectItem.coupon || null,
    item: selectItem.item,
    quantity: selectItem.quantity,
    setmenu: selectItem.setmenu,
    setmenu_details: []
  }

  // 単品の場合、カートへ追加
  const cart = this.$store.getters.cart
  cart.item_list.push(item)
  this.$store.dispatch('setCart', cart)

  // カート画面に遷移
  this.$router.push({ name: 'Cart' })
}
function addSingleItem2 (selectItem) {
  const item = {
    coupon_cd: selectItem.coupon || null,
    item: selectItem.item,
    quantity: selectItem.quantity,
    setmenu: selectItem.setmenu,
    setmenu_details: []
  }

  // 単品の場合、カートへ追加
  const cart = this.$store.getters.cart
  cart.item_list.push(item)
  this.$store.dispatch('setCart', cart)

  // カート画面に遷移
  // (history.back対策)遷移先の履歴に上書きする
  this.$router.replace({ name: 'Cart' })
}

export default {
  data () {
    return {
    }
  },
  methods: {
    addSingleItem,
    addSingleItem2
  }
}



// WEBPACK FOOTER //
// ./src/mixins/AddSingleItemMixin.js